import { baseUrl } from "./baseUrl";

// eslint-disable-next-line import/prefer-default-export
export const getExportToXLSRoute = () => [`${baseUrl}`, "xls-generator-api", "xlsFile"].join("/");
